import _jsx from "@babel/runtime/helpers/jsx";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _dec, _dec2, _class, _class2;
var _excluded = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import InputLabel from '@mui/material/InputLabel';
import AppContext from '../../../context';
import messages from '../coursesMessges';
import { getContentCategoriesForFilter, isSupportAdminAuth, isWhitelabeledOrganization } from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';
// eslint-disable-next-line css-modules/no-unused-class
import s from './Filter.scss';
import { ToolbarSelectField } from '../../../components/statelessComponents/TableToolbar/Forms';
import SkholeIcon42 from '../../../components/statelessComponents/Icons/SkholeIcon42';
import FilterIcon from '../../../components/statelessComponents/Icons/FiltersIcon';
import ColumnIcon from '../../../components/statelessComponents/Icons/ColumnIcon';
import GridIcon from '../../../components/statelessComponents/Icons/GridIcon';
import CategoryCollapse from './CategoryCollapse';
import { COURSE_TYPES_FILTER_VALUES } from '../../../constants';
import intlPropTypes from '../../../constants/intlPropTypes';
var IconComponent = function IconComponent(_ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SkholeIcon42, _extends({}, rest, {
    className: classNames(className, s.selectIcon)
  }));
};
var selectMenuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
var tooltipWrapperStyle = {
  display: 'inline-flex'
};
var Filter = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    lang: state.intl.locale,
    loadingLessons: state.homeLessons.loading
  };
}), injectIntl(_class = _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Filter, _React$Component);
  var _super = _createSuper(Filter);
  function Filter() {
    var _this;
    _classCallCheck(this, Filter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "anchorEl", null);
    _defineProperty(_assertThisInitialized(_this), "anchorTagsEl", null);
    _defineProperty(_assertThisInitialized(_this), "handleDisplayListClick", function () {
      _this.props.setIsColumnDisplayMode(true);
    });
    _defineProperty(_assertThisInitialized(_this), "handleDisplayPlateClick", function () {
      _this.props.setIsColumnDisplayMode(false);
    });
    return _this;
  }
  _createClass(Filter, [{
    key: "render",
    value: function render() {
      var _classNames,
        _this2 = this;
      var _this$props = this.props,
        filter = _this$props.filter,
        _this$props$onFilterC = _this$props.onFilterChange,
        onFilterChange = _this$props$onFilterC === void 0 ? function () {} : _this$props$onFilterC,
        contentLangId = _this$props.contentLangId,
        _this$props$onContent = _this$props.onContentLanguageChange,
        onContentLanguageChange = _this$props$onContent === void 0 ? function () {} : _this$props$onContent,
        _this$props$onChangeS = _this$props.onChangeSort,
        onChangeSort = _this$props$onChangeS === void 0 ? function () {} : _this$props$onChangeS,
        _this$props$onChangeS2 = _this$props.onChangeSortOrder,
        onChangeSortOrder = _this$props$onChangeS2 === void 0 ? function () {} : _this$props$onChangeS2,
        sortValue = _this$props.sortValue,
        sortOrderValue = _this$props.sortOrderValue,
        search = _this$props.search,
        lang = _this$props.lang,
        clearFilter = _this$props.clearFilter,
        hasPristineState = _this$props.hasPristineState,
        auth = _this$props.auth,
        pendingCategories = _this$props.pendingCategories,
        categories = _this$props.categories,
        isIndexExpanded = _this$props.isIndexExpanded,
        loadingCourses = _this$props.loadingCourses,
        toggleSelectAllContentCategories = _this$props.toggleSelectAllContentCategories,
        handleCollapseIndex = _this$props.handleCollapseIndex,
        handleToggleContentCategory = _this$props.handleToggleContentCategory,
        handleExpandIndex = _this$props.handleExpandIndex,
        loadingContentCategories = _this$props.loadingContentCategories,
        isLoadedContentCategories = _this$props.isLoadedContentCategories,
        isFiltersMobileExpanded = _this$props.isFiltersMobileExpanded,
        handleFiltersMobileExpanded = _this$props.handleFiltersMobileExpanded,
        displayItemsInColumn = _this$props.displayItemsInColumn,
        _this$props$intl = _this$props.intl,
        formatMessage = _this$props$intl.formatMessage,
        locale = _this$props$intl.locale,
        loadingLessons = _this$props.loadingLessons,
        type = _this$props.type,
        onContentTypeChange = _this$props.onContentTypeChange,
        isTagsIndexExpanded = _this$props.isTagsIndexExpanded,
        pendingTags = _this$props.pendingTags,
        tags = _this$props.tags,
        toggleSelectAllTags = _this$props.toggleSelectAllTags,
        handleToggleTag = _this$props.handleToggleTag,
        loadingTags = _this$props.loadingTags,
        isLoadedTags = _this$props.isLoadedTags,
        handleCollapseTagsIndex = _this$props.handleCollapseTagsIndex,
        handleExpandTagsIndex = _this$props.handleExpandTagsIndex,
        wereTagsEmpty = _this$props.wereTagsEmpty,
        amountApplied = _this$props.amountApplied;
      var _this$context = this.context,
        whitelabeling = _this$context.whitelabeling,
        contentLangs = _this$context.contentLangs;
      var isSearchEmpty = search.trim().length < 3;
      var serviceNamePossessive = _.get(whitelabeling, "serviceNamePossessive.".concat(lang), formatMessage(messages.serviceNamePossessive));
      var serviceName = _.get(whitelabeling, "serviceName.".concat(lang), 'Skhole');
      var serviceNameToUse = lang === 'fi-FI' ? serviceNamePossessive : serviceName;
      var courseTypes = [{
        value: '',
        tooltipValue: formatMessage(messages.allCoursesBtnTooltip),
        label: /*#__PURE__*/React.createElement(FormattedMessage, messages.allCoursesBtnLabel),
        disabled: true
      }].concat(_toConsumableArray(!isWhitelabeledOrganization(_.get(auth, 'user.mainGroup')) || _.get(whitelabeling, 'allowServiceNameFilter') ? [{
        value: COURSE_TYPES_FILTER_VALUES.SKHOLE,
        tooltipValue: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.skholeCoursesBtnToolTip, {
          values: {
            serviceNameToUse: serviceNameToUse
          }
        })),
        label: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.skholeCoursesBtnLabel, {
          values: {
            serviceNamePossessive: serviceNamePossessive
          }
        }))
      }] : []), _toConsumableArray(isSupportAdminAuth(auth) ? [{
        value: COURSE_TYPES_FILTER_VALUES.CUSTOMERS_COURSES,
        tooltipValue: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.customersCoursesToolTip, {
          values: {
            serviceNameToUse: serviceNameToUse
          }
        })),
        label: /*#__PURE__*/React.createElement(FormattedMessage, messages.customersCourses)
      }] : []), _toConsumableArray(isWhitelabeledOrganization(_.get(auth, 'user.mainGroup')) ? [{
        value: COURSE_TYPES_FILTER_VALUES.MY_COURSES,
        tooltipValue: formatMessage(messages.favouriteCoursesBtnTooltip),
        label: /*#__PURE__*/React.createElement(FormattedMessage, messages.favouriteCoursesBtn)
      }] : [{
        value: COURSE_TYPES_FILTER_VALUES.MY_COURSES,
        tooltipValue: formatMessage(messages.myCoursesBtnTooltip),
        label: /*#__PURE__*/React.createElement(FormattedMessage, messages.myCoursesBtn)
      }]));
      var contentTypeFilterOptions = [{
        value: 'all',
        tooltipValue: formatMessage(messages.allLabel),
        label: /*#__PURE__*/React.createElement(FormattedMessage, messages.allLabel)
      }, {
        value: 'normal',
        tooltipValue: formatMessage(messages.normalType),
        label: /*#__PURE__*/React.createElement(FormattedMessage, messages.normalType)
      }, {
        value: 'livestream',
        tooltipValue: formatMessage(messages.livestreamType),
        label: /*#__PURE__*/React.createElement(FormattedMessage, messages.livestreamType)
      }, {
        value: 'podcast',
        tooltipValue: formatMessage(messages.podcastType),
        label: /*#__PURE__*/React.createElement(FormattedMessage, messages.podcastType)
      }];
      return /*#__PURE__*/_jsx("section", {
        className: s.container
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "D5KLV3JA3vlZzj9osVSlO",
        className: classNames(s.filterBtn, s.filterBtnRoot, s.browseCategoryBtn, s.mobileFilters, s.mobileFiltersCollapseBtn),
        onClick: handleFiltersMobileExpanded
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.filtersAndOrderBtnLabel), /*#__PURE__*/_jsx("div", {}, void 0, !hasPristineState && !!amountApplied && /*#__PURE__*/_jsx("span", {
        className: s.mobileFilterAmountApplied
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.amountAppliedLabel, {
        values: {
          amount: amountApplied
        }
      }))), !isFiltersMobileExpanded ? /*#__PURE__*/_jsx(FilterIcon, {
        className: s.filterIcon
      }) : /*#__PURE__*/_jsx(CloseIcon, {
        className: s.filterIcon
      }))), /*#__PURE__*/_jsx("section", {
        className: classNames(s.filter, (_classNames = {}, _defineProperty(_classNames, s.filtersMobileExpanded, isFiltersMobileExpanded), _defineProperty(_classNames, s.authorizedFilterTagsHidden, !tags.length && wereTagsEmpty && isLoggedIn(auth) && getContentCategoriesForFilter(auth)), _defineProperty(_classNames, s.authorizedFilterContentCategoriesHidden, !!tags.length && isLoggedIn(auth) && !getContentCategoriesForFilter(auth)), _defineProperty(_classNames, s.authorizedFilterContentCategoriesAndTagsHidden, !tags.length && wereTagsEmpty && isLoggedIn(auth) && !getContentCategoriesForFilter(auth)), _defineProperty(_classNames, s.unAuthorizedFilterContentCategoriesHidden, !!tags.length && !isLoggedIn(auth)), _defineProperty(_classNames, s.unAuthorizedFilterContentCategoriesAndTagsHidden, !tags.length && !isLoggedIn(auth)), _defineProperty(_classNames, s.authorizedLangFieldHidden, !!search && getContentCategoriesForFilter(auth)), _defineProperty(_classNames, s.authorizedLangFieldAndContentCategoriesHidden, !!search), _defineProperty(_classNames, s.unAuthorizedLangFieldHidden, !!search && !isLoggedIn(auth)), _classNames))
      }, void 0, !search && isLoggedIn(auth) && !!getContentCategoriesForFilter(auth) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.browseByCategoryBtnTooltip)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.categoriesBlock
      }, void 0, /*#__PURE__*/_jsx(InputLabel, {
        className: s.categoriesFilterLabel
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.categoriesBlockLabel)), /*#__PURE__*/React.createElement(Button, {
        "data-test-id": "jkpUm1VY_8xJyI6_V7N5r",
        className: classNames(s.filterBtn, s.filterBtnRoot, s.browseCategoryBtn, s.categoryArea),
        classes: {
          focusVisible: s.focused
        },
        disabled: loadingCourses || loadingContentCategories || loadingLessons || !isLoadedContentCategories,
        ref: function ref(node) {
          _this2.anchorEl = node;
        },
        onClick: isIndexExpanded ? handleCollapseIndex : handleExpandIndex,
        disableFocusRipple: true
      }, pendingCategories.length && pendingCategories.length !== categories.length ? formatMessage(messages.browseByCategorySelectedBtnLabel, {
        amountSelected: pendingCategories.length
      }) : formatMessage(messages.browseByContentCategoryBtnLabel), /*#__PURE__*/_jsx(SkholeIcon42, {
        className: classNames(s.selectIcon, _defineProperty({}, s.flipHorizontally, isIndexExpanded))
      })))), /*#__PURE__*/_jsx(CategoryCollapse, {
        loadingCourses: loadingCourses,
        pendingCategories: pendingCategories,
        toggleSelectAllContentCategories: toggleSelectAllContentCategories,
        categories: categories,
        handleToggleContentCategory: handleToggleContentCategory,
        handleCollapseIndex: handleCollapseIndex,
        isIndexExpanded: isIndexExpanded,
        isLoadedContentCategories: isLoadedContentCategories,
        anchorEl: function anchorEl() {
          return _this2.anchorEl;
        },
        nameMapper: function nameMapper(item) {
          return item.name[locale];
        }
      })), !search && (!!tags.length || !wereTagsEmpty) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.browseByTagBtnTooltip)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.categoriesBlock
      }, void 0, /*#__PURE__*/_jsx(InputLabel, {
        className: s.categoriesFilterLabel
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.tagsBlockLabel)), /*#__PURE__*/React.createElement(Button, {
        "data-test-id": "RcQ1gWhLYuaRbXGZmsZ1x",
        className: classNames(s.filterBtn, s.filterBtnRoot, s.browseCategoryBtn, s.tagsArea),
        classes: {
          focusVisible: s.focused
        },
        disabled: loadingCourses || loadingTags || loadingLessons || !isLoadedTags,
        ref: function ref(node) {
          _this2.anchorTagsEl = node;
        },
        onClick: isTagsIndexExpanded ? handleCollapseTagsIndex : handleExpandTagsIndex,
        disableFocusRipple: true
      }, pendingTags.length && pendingTags.length !== tags.length ? formatMessage(messages.browseByCategorySelectedBtnLabel, {
        amountSelected: pendingTags.length
      }) : formatMessage(messages.browseByCategoryBtnLabel), /*#__PURE__*/_jsx(SkholeIcon42, {
        className: classNames(s.selectIcon, _defineProperty({}, s.flipHorizontally, isTagsIndexExpanded))
      })))), /*#__PURE__*/_jsx(CategoryCollapse, {
        loadingCourses: loadingCourses,
        pendingCategories: pendingTags,
        toggleSelectAllContentCategories: toggleSelectAllTags,
        categories: tags,
        handleToggleContentCategory: handleToggleTag,
        handleCollapseIndex: handleCollapseTagsIndex,
        isIndexExpanded: isTagsIndexExpanded,
        isLoadedContentCategories: isLoadedTags,
        anchorEl: function anchorEl() {
          return _this2.anchorTagsEl;
        },
        nameMapper: function nameMapper(item) {
          return item.name;
        }
      })), /*#__PURE__*/_jsx("div", {
        className: classNames(s.flex, s.courseTypeFilters, s.classificationArea, _defineProperty({}, s.hide, !isLoggedIn(auth)))
      }, void 0, isLoggedIn(auth) && /*#__PURE__*/_jsx(ToolbarSelectField, {
        label: formatMessage(messages.classificationFilterLabel),
        InputLabelProps: {
          classes: {
            formControl: s.selectLabel
          }
        },
        value: filter || 'all',
        onChange: onFilterChange,
        classes: {
          textField: s.filterSelect,
          selectRoot: s.filterSelect,
          formRoot: s.formRootAllCourses,
          selectIcon: s.toolbarSelectIcon,
          select: s.allCoursesSelect
        },
        SelectProps: {
          MenuProps: selectMenuProps
        },
        disabled: loadingCourses,
        role: "button"
      }, void 0, courseTypes.map(function (option) {
        return /*#__PURE__*/_jsx(MenuItem, {
          className: s.font,
          value: option.value || 'all'
        }, option.value + 1, /*#__PURE__*/_jsx(Tooltip, {
          title: option.tooltipValue
        }, void 0, /*#__PURE__*/_jsx("div", {
          className: s.courseTypeMenuItems
        }, void 0, option.label)));
      }))), /*#__PURE__*/_jsx("div", {
        className: classNames(s.flex, s.courseTypeFilters, s.typeArea, {
          // [s.hide]: !isLoggedIn(auth),
        })
      }, void 0, /*#__PURE__*/_jsx(ToolbarSelectField, {
        label: formatMessage(messages.courseTypeFilterLabel),
        InputLabelProps: {
          classes: {
            formControl: s.selectLabel
          }
        },
        value: type || 'all',
        onChange: onContentTypeChange,
        classes: {
          textField: s.filterSelect,
          selectRoot: s.filterSelect,
          formRoot: s.formRootAllCourses,
          selectIcon: s.toolbarSelectIcon,
          select: s.allCoursesSelect
        },
        SelectProps: {
          MenuProps: selectMenuProps
        },
        disabled: loadingCourses,
        role: "button"
      }, void 0, contentTypeFilterOptions.map(function (option) {
        return /*#__PURE__*/_jsx(MenuItem, {
          className: s.font,
          value: option.value
        }, "content-type-filter-home-page-".concat(option.value), /*#__PURE__*/_jsx(Tooltip, {
          title: option.tooltipValue
        }, void 0, /*#__PURE__*/_jsx("div", {
          className: s.courseTypeMenuItems
        }, void 0, option.label)));
      }))), !search && /*#__PURE__*/_jsx("div", {
        className: classNames(s.flex, s.courseTypeFilters, s.languageArea)
      }, void 0, /*#__PURE__*/_jsx(ToolbarSelectField, {
        label: formatMessage(messages.languageFilterLabel),
        InputLabelProps: {
          classes: {
            formControl: s.selectLabel
          }
        },
        value: contentLangId || 'all',
        onChange: onContentLanguageChange,
        classes: {
          textField: s.filterSelect,
          selectRoot: s.filterSelect,
          formRoot: s.formRootAllCourses,
          selectIcon: s.toolbarSelectIcon,
          select: s.allCoursesSelect
        },
        SelectProps: {
          MenuProps: selectMenuProps
        },
        disabled: loadingCourses,
        role: "button"
      }, void 0, [{
        _id: 'all',
        name: formatMessage(messages.allLabel)
      }].concat(_toConsumableArray(contentLangs)).map(function (option) {
        return /*#__PURE__*/_jsx(MenuItem, {
          className: s.font,
          value: option._id
        }, "language-filter-home-page-".concat(option._id), /*#__PURE__*/_jsx(Tooltip, {
          title: option.lang
        }, void 0, /*#__PURE__*/_jsx("div", {
          className: s.courseTypeMenuItems
        }, void 0, option.name)));
      }))), /*#__PURE__*/_jsx("div", {
        className: classNames(s.flex, s.orderFilter, s.orderArea)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.orderFilterInputs
      }, void 0, /*#__PURE__*/_jsx("span", {
        className: s.sortOrderLabel
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.orderTitle)), /*#__PURE__*/_jsx(Select, {
        value: sortValue,
        onChange: onChangeSort,
        className: s.sortField,
        classes: {
          select: s.sortFieldSelect,
          disabled: s.disabledSelect
        },
        MenuProps: _objectSpread({}, selectMenuProps),
        disabled: loadingCourses || loadingLessons || loadingContentCategories || loadingTags,
        IconComponent: IconComponent
      }, void 0, /*#__PURE__*/_jsx(MenuItem, {
        value: "publishedUpdatedDate"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.publishDateItemLabel)), isSearchEmpty && isLoggedIn(auth) && /*#__PURE__*/_jsx(MenuItem, {
        value: "lastAccessDate"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.recentlyAccessedMenuItemLabel)), isSearchEmpty && isLoggedIn(auth) && /*#__PURE__*/_jsx(MenuItem, {
        value: "progress"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.progressMenuItemLabel)), /*#__PURE__*/_jsx(MenuItem, {
        value: "name"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.nameMenuItemLabel)), isSearchEmpty && /*#__PURE__*/_jsx(MenuItem, {
        value: "completed"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.popularityMenuItemLabel))), /*#__PURE__*/_jsx(Select, {
        value: sortOrderValue,
        onChange: onChangeSortOrder,
        className: s.sortOrderField,
        disabled: loadingCourses || loadingLessons || loadingContentCategories || loadingTags,
        MenuProps: _objectSpread({}, selectMenuProps),
        IconComponent: IconComponent
      }, void 0, /*#__PURE__*/_jsx(MenuItem, {
        value: "asc"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.ascendingMenuItemLabel)), /*#__PURE__*/_jsx(MenuItem, {
        value: "desc"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.descendingMenuItemLabel))))), /*#__PURE__*/_jsx("div", {
        className: classNames(s.clearFilters, s.clearArea)
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.clearFilterLong)
      }, void 0, /*#__PURE__*/_jsx("span", {
        style: tooltipWrapperStyle
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "juayHYYviTO0EDym_SNP6",
        color: "primary",
        onClick: clearFilter,
        variant: "outlined",
        classes: {
          root: s.clearFiltersRoot
        },
        disabled: hasPristineState || loadingCourses || loadingLessons || loadingContentCategories || loadingTags
      }, void 0, /*#__PURE__*/_jsx("span", {
        className: s.clearFilterLongMsg
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.clearFilterLong)), /*#__PURE__*/_jsx("span", {
        className: s.clearFilterShotMsg
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.clearFilterShot)))))), /*#__PURE__*/_jsx("div", {
        className: classNames(s.flex, s.modeIconsContainer, s.modeArea)
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.showList)
      }, void 0, /*#__PURE__*/_jsx("span", {
        style: tooltipWrapperStyle
      }, void 0, /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "zVufaq4yS94Pbj-IRm7VV",
        onClick: this.handleDisplayListClick,
        classes: {
          root: s.displayModeBtn
        },
        disabled: displayItemsInColumn || loadingCourses || loadingLessons,
        "aria-label": formatMessage(messages.showList)
      }, void 0, /*#__PURE__*/_jsx(ColumnIcon, {
        className: classNames(s.displayModeIcon, _defineProperty({}, s.disabledIcon, displayItemsInColumn || loadingCourses || loadingLessons))
      })))), /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.showGrid)
      }, void 0, /*#__PURE__*/_jsx("span", {
        style: tooltipWrapperStyle
      }, void 0, /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "kx_rspIrafuPWQDmIVOvs",
        onClick: this.handleDisplayPlateClick,
        classes: {
          root: s.displayModeBtn
        },
        disabled: !displayItemsInColumn || loadingCourses || loadingLessons,
        "aria-label": formatMessage(messages.showGrid)
      }, void 0, /*#__PURE__*/_jsx(GridIcon, {
        className: classNames(s.displayModeIcon, _defineProperty({}, s.disabledIcon, !displayItemsInColumn || loadingCourses || loadingLessons))
      })))))));
    }
  }]);
  return Filter;
}(React.Component), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class);
export { Filter as default };